// extracted by mini-css-extract-plugin
export default {"container":"BackgroundImage_container__ct4Tx"};